import React, { type ForwardedRef } from 'react';
import { PageActionDiscriminator } from 'autogen/swagger/all';
import withAsyncStatus from 'components/hoc/WithAsyncStatus/WithAsyncStatus';
import withSpinner from 'components/hoc/WithSpinner/WithSpinner';
import { withIcon } from 'components/hoc/withIcon/WithIcon';
import type { PageActionProps } from 'components/shared/Routing/PageAction';
import InlineCustomActionButton from './InlineCustomActionButton';
import InlineLinkActionButton from './InlineLinkActionButton';
import type { InlineButtonProps } from './shared/types/inlineButton';

export type PageActionInlineButtonProps = PageActionProps & InlineButtonProps<HTMLAnchorElement | HTMLButtonElement>;

const InlinePageActionButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, PageActionInlineButtonProps>(
    ({ action, ...restProps }, ref) =>
        PageActionDiscriminator(
            action,
            (customAction) => (
                <InlineCustomActionButton
                    ref={ref as ForwardedRef<HTMLButtonElement>}
                    action={customAction.action}
                    {...restProps}
                />
            ),
            (linkAction) => (
                <InlineLinkActionButton
                    ref={ref as ForwardedRef<HTMLAnchorElement>}
                    action={linkAction.action}
                    {...restProps}
                />
            ),
            () => {
                throw new Error('invalid action type');
            }
        )
);

export default Object.assign(InlinePageActionButton, {
    WithIcon: withIcon(InlinePageActionButton),
    WithAsyncStatus: withAsyncStatus(InlinePageActionButton),
    WithSpinner: withSpinner(withAsyncStatus(InlinePageActionButton))
});
